import React from 'react'
import * as styles from './sectionGrid.module.scss'
import SectionImageCards from '../SectionImageCards/SectionImageCards'
import ProductCard from '../ProductCard/ProductCard'
import RecipeCard from '../RecipeCard/RecipeCard'
import RecipeProductCard from '../RecipeProductCard/RecipeProductCard'
import FilmsCards from '../FilmsCards/FilmsCards'
import RegerativeProductCards from '../RegenerativeProductCard/RegerativeProductCards'
import BlogCards from '../BlogCards/BlogCards'
const SectionGrid = ({data}) => {
    const {type} = data
    switch(type){
      case "HomePageGrid":
        return <ProductCard gridItems = {data}/>
      case "RecipePage-recipeGrid":
        return <RecipeCard gridItems = {data}/>
      case "RecipePage-productGrid":
        return <RecipeProductCard gridItems = {data}/>
      case "Tree-Corpse-Cards":
        return <SectionImageCards gridItems = {data}/>
      case "Films-Cards":
        return <FilmsCards gridItems = {data}/>
      case "Regenerative-Cards":
        return <RegerativeProductCards gridItems = {data}/>
      case "Blog-Cards":
        return <BlogCards gridItems = {data}/>
    }
  return (
    <div>
    </div>
  )
}

export default SectionGrid